import React, { useState, useEffect } from "react";
import { FaEye, FaEdit, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../components/DeleteBlogModal";
import { apiRequestHandler } from "../../apiConfig/service";
import { toast } from "react-toastify";
import { url } from "../../apiConfig/ApiConfig";
import { formatDate } from "../../utils/formatedDate";
import DataTable from "react-data-table-component";

const getServices = async (endPoint, token) => {
  const res = await apiRequestHandler({
    endPoint,
    headers: { Authorization: `Bearer ${token}` },
  });
  return res?.data;
};

const ServiceManagement = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [services, setServices] = useState([]);
  const [filteredServices, setFilteredServices] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [serviceToDelete, setServiceToDelete] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const navigate = useNavigate();

  const fetchServices = async () => {
    try {
      setIsLoading(true);
      const res = await getServices("getServices", localStorage.getItem("token"));
      if (res) {
        const sorted = res.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setServices(sorted);
      } else {
        toast.error("Failed to fetch services");
      }
    } catch (err) {
      toast.error("Error while fetching services");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchServices();
  }, []);

  useEffect(() => {
    const filtered =
      services?.filter(
        (service) =>
          service?.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          service?.serviceName?.toLowerCase().includes(searchTerm.toLowerCase())
      ) || [];
    setFilteredServices(filtered);
  }, [searchTerm, services]);

  const handleDeleteService = async (id) => {
    try {
      setIsLoading(true);
      const res = await apiRequestHandler({
        method: "DELETE",
        endPoint: `${url}/service/${id}`,
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      if (res?.success) {
        toast.success(res?.message);
        fetchServices();
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  const columns = [
    {
      name: 'Sr No.',
      selector: (row, index) => (currentPage - 1) * 10 + index + 1,
      width: '80px',
    },
    {
      name: "Service Name",
      selector: (row) => row.serviceName,
      sortable: true,
    },
    {
      name: "Title",
      selector: (row) => row.title,
      sortable: true,
    },
    {
      name: "Created At",
      selector: (row) => formatDate(row.createdAt),
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <FaEye
            title="View"
            style={{ color: "#064a8c", marginRight: "10px", cursor: "pointer" }}
            onClick={() =>
              navigate("/admin/add-service", {
                state: { service: row, mode: "view" },
              })
            }
          />
          <FaEdit
            title="Edit"
            style={{ color: "#ff9800", marginRight: "10px", cursor: "pointer" }}
            onClick={() =>
              navigate("/admin/add-service", {
                state: { service: row, mode: "edit" },
              })
            }
          />
          <FaTrash
            title="Delete"
            style={{ color: "#f44336", cursor: "pointer" }}
            onClick={() => {
              setServiceToDelete(row);
              setShowDeleteModal(true);
            }}
          />
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <div style={{ minHeight: "100vh", padding: "20px", background: "#f5f7fa" }}>
      <div style={{ backgroundColor: "#fff", padding: "20px", borderRadius: "10px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <h4 style={{ margin: 0 }}>Service Management</h4>
          <button
            onClick={() => navigate("/admin/add-service")}
            style={{
              background: "linear-gradient(to bottom right, #163252, #0081ff)",
              color: "#fff",
              border: "none",
              padding: "8px 16px",
              borderRadius: "5px",
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            + Add Service
          </button>
        </div>

        <DeleteModal
          show={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          theme="dark"
          onConfirm={() => {
            handleDeleteService(serviceToDelete?._id);
            setShowDeleteModal(false);
          }}
        />
      </div>

      <div className="modifyTable" style={{ borderRadius: "10px", marginTop: "20px" }}>
        <DataTable
          title=""
          columns={columns}
          data={filteredServices}
          pagination
          highlightOnHover
          onChangePage={setCurrentPage}
          paginationDefaultPage={currentPage}
          responsive
          striped
          progressPending={isLoading}
          subHeader
          subHeaderComponent={
            <input
              type="text"
              placeholder="Search by service title or name..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                padding: "8px 12px",
                borderRadius: "6px",
                border: "1px solid #ddd",
                fontSize: "14px",
                width: "250px",
              }}
            />
          }
        />
      </div>
    </div>
  );
};

export default ServiceManagement;
